import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";

//import { AngularFireModule } from 'angularfire2';
//import { AngularFireDatabaseModule } from 'angularfire2/database';

//import { environment } from '../environments/environment';

import { HttpClientModule } from "@angular/common/http";

import { Interceptor } from "./app-interceptor.module";

import { LoadingBarModule } from "@ngx-loading-bar/core";

import { SharedModule } from "./shared/shared.module";
import { LoginComponent } from "./login";
import { PanelModule } from "./panel/panel.module";
import { OopsComponent } from "./oops";

@NgModule({
  declarations: [AppComponent, LoginComponent, OopsComponent],
  imports: [
    //AngularFireDatabaseModule,
    //AngularFireModule.initializeApp(environment.firebase),
    AppRoutingModule,
    BrowserModule,
    LoadingBarModule,
    PanelModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    Interceptor,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
